module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enjoy-chat"
  }, [_c('h1', [_vm._v("温馨提示")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.download($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/alpha.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("下载 Alpha 桌面端")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c"
  }, [_c('p', [_vm._v("尊敬的用户，为了全面提升享聊体验，享聊功能已迁移至桌面端，请点击下方按钮下载使用。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b71996"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/app.vue
// module id = 2182
// module chunks = 9